import React from 'react';
import {Helmet} from 'react-helmet-async';

const TerminiServizio = () => {
  return (
    <>
      <Helmet>
        <title>Termini di Servizio - Realizzazione Siti Web Napoli</title>
        <meta name="description" content="Termini e condizioni di servizio di Realizzazione Siti Web Napoli. Condizioni generali di contratto." />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://realizzazionesitiweb-napoli.it/termini" />
      </Helmet>
      <div className="pt-24 min-h-screen bg-white">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl lg:text-4xl font-poppins font-bold text-napoli-blu mb-8 text-center mt-12 md:mt-0">
              Termini di Servizio
            </h1>
            <div className="bg-napoli-light rounded-xl p-8 space-y-6">
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">1. Accettazione dei Termini</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  Utilizzando i servizi di Realizzazione Siti Web Napoli, accetti integralmente i presenti termini e condizioni.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">2. Servizi Offerti</h2>
                <p className="text-napoli-blu leading-relaxed font-medium mb-3">
                  La nostra web agency offre i seguenti servizi:
                </p>
                <ul className="list-disc list-inside text-napoli-blu space-y-2 font-medium">
                  <li>Realizzazione siti web professionali</li>
                  <li>Sviluppo e-commerce</li>
                  <li>Servizi SEO e web marketing</li>
                  <li>Social media management</li>
                  <li>Branding e identità visiva</li>
                  <li>Consulenza in intelligenza artificiale</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">3. Tempi di Consegna</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  I tempi di consegna variano in base al tipo di progetto e vengono concordati in fase di preventivo. Ci impegniamo a rispettare le scadenze concordate, salvo cause di forza maggiore.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">4. Pagamenti</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  I pagamenti seguono le modalità concordate nel contratto. Generalmente richiediamo un acconto del 50% all'avvio del progetto e il saldo alla consegna.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">5. Proprietà Intellettuale</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  Una volta completato il pagamento, il cliente acquisisce la piena proprietà del sito web realizzato. Manteniamo il diritto di utilizzare il progetto nel nostro portfolio, salvo diversi accordi.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">6. Garanzia e Assistenza</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  Offriamo garanzia sui nostri lavori e assistenza tecnica secondo quanto specificato nel contratto. L'assistenza può variare da 3 a 12 mesi in base al pacchetto scelto.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">7. Limitazione di Responsabilità</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  La nostra responsabilità è limitata al valore del contratto stipulato. Non siamo responsabili per danni indiretti o perdite di profitto derivanti dall'utilizzo dei nostri servizi.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">8. Modifiche ai Termini</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  Ci riserviamo il diritto di modificare questi termini in qualsiasi momento. Le modifiche saranno pubblicate su questa pagina e entreranno in vigore immediatamente.
                </p>
              </section>
              
              <section>
                <h2 className="text-xl font-semibold text-napoli-blu mb-3">9. Contatti</h2>
                <p className="text-napoli-blu leading-relaxed font-medium">
                  Per qualsiasi domanda sui presenti termini, contattaci a: <br />
                  Email: info@realizzazionesitiwebnapoli.com <br />
                  Telefono: +39 350 070 3118
                </p>
              </section>
              
              <div className="text-sm text-gray-500 border-t border-gray-200 pt-4">
                <p>Ultimo aggiornamento: Gennaio 2024</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TerminiServizio;